import './MessageCloud.scss';

import React, { useMemo } from 'react'
import { ChatMessage } from '../../models/LLM'
import classNames from 'classnames';
import MDEditor from '@uiw/react-md-editor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

type Props = {
  message?: ChatMessage;
  children?: React.ReactNode;
}

export default function MessageCloud({ message, children }: Props) {
  const messageContent = useMemo(() => children || message?.text || "Message", [message, children]);

  return (
    <div className={classNames("message-cloud", { user: message?.isUserPrompt })}>
      {typeof messageContent === 'object'
        ? messageContent
        : message?.isAlert
          ? (
            <div className="text-danger">
              <FontAwesomeIcon icon={solid('exclamation-circle')} />
              <span className="ms-1">{messageContent}</span>
            </div>
          )
          : (
            <div data-color-mode="light">
              <MDEditor.Markdown className="bg-transparent" source={messageContent} />
            </div>
          )
      }
    </div>
  )
}